import { useSearchParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { useMeta } from '@/hooks/useMeta';

export default function ThankYou() {
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get('customerid');

  useMeta({
    title: 'Thank You | Application Submitted | AmericanTrademark Firm',
    description: 'Your application has been submitted successfully. Our team will review your details and reach out within 24 hours.',
    keywords: 'thank you, application submitted, trademark registration, AmericanTrademark Firm',
  });

  return (
    <div className="min-h-screen bg-[#F4F4F5] flex items-center justify-center px-6" data-testid="thankyou-page">
      <div className="max-w-lg w-full bg-white border-2 border-[#09090B] shadow-[8px_8px_0px_rgba(9,9,11,1)] p-10 text-center">
        <CheckCircle className="w-16 h-16 text-[#002FA7] mx-auto mb-6" />
        <h1 className="font-heading font-black text-3xl tracking-tight text-[#09090B] mb-4">
          Thank You!
        </h1>
        <p className="text-base text-zinc-600 font-body leading-relaxed mb-2">
          Your application has been submitted successfully.
        </p>
        {customerId && (
          <p className="text-sm text-zinc-500 font-body mb-6">
            Your reference ID: <span className="font-bold text-[#09090B]">{customerId}</span>
          </p>
        )}
        <p className="text-base text-zinc-600 font-body leading-relaxed mb-8">
          Our team will review your details and reach out within 24 hours. In the meantime, feel free to explore our services.
        </p>
        <Link
          to="/"
          className="inline-block bg-[#002FA7] text-white hover:bg-[#002480] transition-colors px-8 py-4 font-bold text-sm tracking-widest uppercase"
          data-testid="thankyou-home-link"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}
